module.exports = __webpack_public_path__ + "img/guia_cotizacion.30d09ecd.png";